import React,{useState} from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {
  exportPostArtworkPng,
  slugifyPostFileName
} from '../lib/exportPostArtworkPng';

const {FiDownload}=FiIcons;

function DownloadPostButton({
  artworkRef,
  headline,
  disabled=false,
  className='secondary-button',
  label='Download',
  loadingLabel='Exporting...',
  showError=true
}) {
  const [loading,setLoading]=useState(false);
  const [error,setError]=useState('');

  const handleClick=async ()=> {
    const node=artworkRef?.current;

    if (!node || loading) {
      return;
    }

    setLoading(true);
    setError('');

    try {
      await exportPostArtworkPng(node,{
        fileName:slugifyPostFileName(headline)
      });
    } catch (err) {
      setError(
        err?.message
        || 'Export failed. The background image may be blocked by CORS.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <span className="download-post-wrap">
      <button
        type="button"
        className={className}
        disabled={disabled || loading}
        onClick={handleClick}
      >
        <SafeIcon
          icon={FiDownload}
          className={loading ? 'regenerate-spinner' : ''}
        />
        {loading ? loadingLabel : label}
      </button>
      {showError && error && (
        <span className="download-post-error" role="alert">
          {error}
        </span>
      )}
    </span>
  );
}

export default DownloadPostButton;
